<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		value = $bindable(),
		element = $bindable(),
		class: className = '',
		required = null,
		disabled = null,
		error = null,
		label = null,
		onchange = null,
		...props
	} = $props();

	let checked = $state(value ? true : false);

	$effect(() => {
		value = checked ? true : false;
	});
</script>

<!-- TODO: we are currently treating checkboxes as a single input, but they should be treated as a group of inputs -->
<InputWrapper class={className} {error}>
	<label class="grid grid-flow-col grid-cols-[auto_1fr] items-center">
		<input
			bind:this={element}
			value="true"
			type="checkbox"
			class={[
				'form-checkbox border-indow-grey-light text-indow-blue focus:border-indow-grey ring-indow-white mr-2 h-8 w-8 content-center rounded-md ring focus:ring-0',
				{
					'bg-indow-grey-light cursor-not-allowed': disabled,
				},
				{ '!border-indow-red': error },
			]}
			{name}
			bind:checked
			{required}
			{disabled}
			{onchange}
			{...props}
		/>
		<span>{label}</span>
	</label>
</InputWrapper>
